import { makeStyles } from '@mui/styles';
import React from 'react';

import { AttachmentsPaper } from '../../../../AttachmentsForm';

const useStyles = makeStyles(theme => ({
    paper: {
        margin: 0,
        marginBottom: theme.spacing(2),
    },
}));

export default function Attachments({
    attachments = [],
    disabled,
    fetchJiraIssue,
    id,
    issueKey,
    uploadJiraIssueAttachment,
}) {
    const handleSubmit = async ({ attachment }) => {
        const formData = new FormData();
        formData.append('file', attachment);
        await uploadJiraIssueAttachment({ formData, id: issueKey });
        fetchJiraIssue({ id: issueKey });
    };
    const classes = useStyles();

    return (
        <AttachmentsPaper
            attachments={attachments}
            className={classes.paper}
            disabled={disabled}
            getHref={file => `maintenance-issue/${issueKey}/attachments/${file.id}`}
            id={id}
            onSubmit={disabled ? undefined : handleSubmit}
        />
    );
}
